import React from 'react';
import { Grid } from '@mui/material';
import styles from './styles';
import StatisticItem from './StatisticItem';
import { StaticImage } from 'gatsby-plugin-image';

const iconsMapping = (id) => {
  switch (id) {
    case 1:
      return <StaticImage src="./graduateIcon.png" alt="graduate" />;
    case 2:
      return <StaticImage src="./caseIcon.png" alt="case" />;
    case 8:
      return <StaticImage src="./moneyIcon.png" alt="money" />;
    case 4:
      return <StaticImage src="./likeIcon.png" alt="like" />;
    default:
      return <StaticImage src="./graduateIcon.png" alt="graduate" />;
  }
};

function Statistic({ statistic = [], justify, variant, noWrapLink }) {
  return (
    <Grid container sx={styles.container}>
      {statistic.map((item) => (
        <Grid
          item
          sx={styles.item}
          key={item.id}
          xs={justify || 6}
          sm={5}
          md={3}
          lg={3}
          xl={statistic.length > 2 ? 3 : Math.floor(12 / statistic.length)}
        >
          <StatisticItem
            {...item}
            variant={variant}
            noWrapLink={noWrapLink}
            image={iconsMapping(item.id)}
          />
        </Grid>
      ))}
    </Grid>
  );
}

export default Statistic;
